
function Page404() {
  return (
    <>
      Errror 404
    </>
  )
}

export default Page404;